import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Nav from "@/components/Nav";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const caseId = params.get("case_id");
  return (
    <div className="min-h-screen bg-[#FAFBFD]">
      <Nav />
      <div className="max-w-md mx-auto px-4 py-16">
        <Card className="trust-card">
          <CardContent className="p-10 text-center">
            <h1 className="text-2xl font-bold text-slate-900">Payment cancelled</h1>
            <p className="text-slate-600 mt-2">No worries — your case is saved as a draft. Come back anytime to unlock your messages.</p>
            <Button data-testid="payment-cancel-back-button" onClick={() => nav(caseId ? `/case/${caseId}` : "/dashboard")} className="mt-6 rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF]">
              Back to my case
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
